import React, { useState } from "react";
import "../../styles/Footer.css";
import FooterBgImg from "../../assets/img/footer/footer-bg-img.svg";
import { ReactComponent as FooterGradientLine } from "../../assets/img/footer/footer-gradient-line.svg";
import { ReactComponent as XIcon } from "../../assets/img/profile/x-icon.svg";
import { ReactComponent as DiscordIcon } from "../../assets/img/footer/discord-icon.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/img/footer/linkedin-icon.svg";
import { ReactComponent as TelegramIcon } from "../../assets/img/footer/telegram-icon.svg";
import { BsInstagram } from "react-icons/bs";
import { Link } from "react-router-dom";
import Container from "./Container";
import ExternalLink from "./ExternalLink";

const SocialMedia = ({ className = "flex" }) => {
  return (
    <div className={`${className} items-center mt-4`}>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://x.com/fundesci"
        className="w-8 h-8 rounded-full bg-[#1F163B] mr-2 flex justify-center items-center"
      >
        <XIcon className="x-icon max-h-4" />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://instagram.com/fundesci"
        className="w-8 h-8 rounded-full bg-[#1F163B] mr-2 flex justify-center items-center"
      >
        <BsInstagram size={20} className="text-white hover:text-primary" />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.linkedin.com/company/fundesci"
        className="w-8 h-8 rounded-full bg-[#1F163B] mr-2 flex justify-center items-center"
      >
        <LinkedinIcon className="linkedin-icon" />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://t.me/Fundesci"
        className="w-8 h-8 rounded-full bg-[#1F163B] mr-2 flex justify-center items-center"
      >
        <TelegramIcon className="telegram-icon" />
      </a>
    </div>
  );
};
const Footer = () => {
  return (
    <footer className="w-full flex flex-col items-center bg-gradient-to-b from-[#1E1541] via-[#1a1230] to-[#120d24] text-white roboto-font z-10 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary/30 to-transparent"></div>
      <div className="absolute top-1/4 -left-40 w-96 h-96 bg-primary/5 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="absolute bottom-1/4 -right-40 w-80 h-80 bg-primary-green/5 rounded-full blur-[100px] pointer-events-none"></div>
      
      {/* Main Footer Content */}
      <section className="w-full flex bg-no-repeat bg-right-bottom justify-center pt-20 pb-12 footer-bottom-section relative z-10">
        <Container>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
            {/* About Section */}
            <div className="lg:col-span-2 flex flex-col">
              <h3 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <span className="w-1 h-8 bg-gradient-to-b from-primary to-primary-green rounded-full"></span>
                About FunDeSci
              </h3>
              <p className="text-white/70 leading-relaxed mb-4">
                FunDeSci is a decentralized platform that connects researchers with global supporters to fund groundbreaking scientific projects. Using blockchain and NFT technology, we make science funding transparent, accessible, and rewarding for everyone involved.
              </p>
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 w-fit mb-6">
                <span className="text-white/60 text-sm">Backed by</span>
                <span className="text-primary-green font-semibold text-sm">DeSci Asia</span>
              </div>
              <SocialMedia className="flex" />
            </div>

            {/* Quick Links */}
            <div className="flex flex-col">
              <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-gradient-to-b from-primary to-primary-green rounded-full"></span>
                Quick Links
              </h3>
              <div className="flex flex-col gap-3">
                <Link to={"/"} className="text-white/70 hover:text-primary-green transition-colors duration-200 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-green/50"></span>
                  Home
                </Link>
                <Link to={"/projects"} className="text-white/70 hover:text-primary-green transition-colors duration-200 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-green/50"></span>
                  Projects
                </Link>
                <Link to={"/discovery"} className="text-white/70 hover:text-primary-green transition-colors duration-200 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-green/50"></span>
                  Discovery
                </Link>
                <Link to={"/communities"} className="text-white/70 hover:text-primary-green transition-colors duration-200 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-green/50"></span>
                  Communities
                </Link>
              </div>
            </div>

            {/* Resources */}
            <div className="flex flex-col">
              <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-gradient-to-b from-primary to-primary-green rounded-full"></span>
                Resources
              </h3>
              <div className="flex flex-col gap-3">
                <Link to={"/about"} className="text-white/70 hover:text-primary-green transition-colors duration-200 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-green/50"></span>
                  About Us
                </Link>
                <Link to={"/contact"} className="text-white/70 hover:text-primary-green transition-colors duration-200 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-green/50"></span>
                  Contact Us
                </Link>
                <Link to={"/FAQ"} className="text-white/70 hover:text-primary-green transition-colors duration-200 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-green/50"></span>
                  FAQ
                </Link>
                <Link to={"/terms-of-service"} className="text-white/70 hover:text-primary-green transition-colors duration-200 flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-green/50"></span>
                  Terms of Service
                </Link>
                <ExternalLink
                  key="documentation"
                  href={"https://fundesci.gitbook.io/docs/introduction/welcome-to-fundesci"}
                  className="!text-white/70 hover:!text-primary-green transition-colors duration-200 flex items-center gap-2"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-green/50"></span>
                  Documentation
                </ExternalLink>
                <ExternalLink
                  key="partnership"
                  href={"https://airtable.com/appgIUJ9M6QYpvlnx/pagsR74puDpO6xvnP/form"}
                  className="!text-primary-green hover:!text-white transition-colors duration-200 flex items-center gap-2 font-medium"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-green"></span>
                  Partner With Us
                </ExternalLink>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* Footer Bottom */}
      <section className="w-full py-6 flex justify-center bg-[#0d0920]/50 backdrop-blur-sm border-t border-white/10 text-sm relative z-10">
        <Container>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60">Copyright © 2026 FunDeSci. All rights reserved.</p>
            <div className="flex items-center gap-6 text-white/60 text-xs">
              <Link to={"/terms-of-service"} className="hover:text-primary-green transition-colors">
                Terms
              </Link>
              <span>•</span>
              <Link to={"/privacy-policy"} className="hover:text-primary-green transition-colors">
                Privacy
              </Link>
              <span>•</span>
              <Link to={"/contact"} className="hover:text-primary-green transition-colors">
                Support
              </Link>
            </div>
          </div>
        </Container>
      </section>
    </footer>
  );
};

export default Footer;
